module.exports = __webpack_public_path__ + "img/symbol_11.83d44aab.png";